/**
 * ============================================================================
 * WeeklyPerformanceChart - Weekly Performance Dual Bar Chart
 * ============================================================================
 */

import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import type { WeeklyPerformance } from '../../types/customerInsights';

interface WeeklyPerformanceChartProps {
  data: WeeklyPerformance[];
}

export function WeeklyPerformanceChart({ data }: WeeklyPerformanceChartProps) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6">
      <h3 className="text-xl font-semibold text-gray-900 mb-6">Weekly Performance</h3>
      {data.length === 0 || data.every((d) => d.bookings === 0) ? (
        <div className="flex items-center justify-center h-[220px] text-gray-400 text-sm">
          No performance data available for this period
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="day" tick={{ fill: '#6b7280', fontSize: 12 }} />
            <YAxis tick={{ fill: '#6b7280', fontSize: 12 }} />
            <Tooltip
              contentStyle={{
                backgroundColor: '#fff',
                border: '1px solid #e5e7eb',
                borderRadius: '12px',
                padding: '12px',
              }}
            />
            <Bar dataKey="bookings" fill="#3b82f6" radius={[8, 8, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
